import React, { useEffect, useMemo, useState } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Modal,
  Form,
  Label,
} from "reactstrap"
import { Link } from "react-router-dom"
// import { useTable, useGlobalFilter, usePagination } from "react-table"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import { useNavigate } from "react-router-dom"

import Pagination from "components/Common/Pagination"
import Loader from "pages/Separate/Loader"
import axios from "axios"
import configure from "configure"
import Swal from "sweetalert2"  
import Select from "react-select"
import editGsImg from "../../../../assets/images/settingImg/editGs.jpg"
import addGsImg from "../../../../assets/images/settingImg/addGs.jpg"
// css
// import "../../../assets/css/Settings/Setting.css"
import "../../../../assets/css/Settings/Setting.css"
import NewPagination from "components/Common/Newpagination"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import { RolesColumns } from "utils/columns/Roles/RolesColumns"
import { staffColumns } from "utils/columns/Human Resource/humanResource"
import { rolesOptions, StaffOption } from "utils/common-options"
import addTeamsImg from "../../../../assets/images/addTeams.jpg"
import editTeamsImg from "../../../../assets/images/editTeams.jpg"

function TableContainer({ columns, data, setAddTeam , setAccessDenied }) {
  const [fixedContent, setFixedContent] = useState(false)

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 300) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])


  // Render the UI for your table
  return (
    <div>
      <div
        className={`flex-column fixed-buttons ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <button
          onClick={() => setAddTeam(true)}
          className="btn btn-purple  fix-btn"
        >
          <i className="fas fa-plus me-2 icon-size"></i>
          <span>Add</span>
        </button>
        <button onClick={() => navigate(-1)} className="btn btn-red  fix-btn">
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col>
          <select
            className=" form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end gap-2">
          <div className="me-4">
            <div className="search-box my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className=" form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <button
              onClick={() => setAddTeam(true)}
              className=" btn btn-purple btn-label"
            >
              {" "}
              <i className="fas fa-plus me-2 icon-size label-icon"></i>Add Lead Tab
            </button>
          </div>
          <div>
            <button
              onClick={() => navigate(-1)}
              className=" btn btn-red btn-label"
            >
              <i className="dripicons-cross icon-center me-2 label-icon"></i>
              CANCEL
            </button>
          </div>
        </Col>
      </Row>
      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead
          className={`${
            fixedContent && page.length >= 10 ? "fixed-oe-setting-header" : ""
          }`}
        >
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  // className={`customShortIcon col-md-${index === 1 || index === 2 ? "4" : "2"}`}
                  className={`${column.className} customShortIcon`}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render("Header")}
                  {column.isInfoIcon ? (
                    <i
                      title="info"
                      className="bx bx-info-circle ms-1 info-icon"
                    ></i>
                  ) : null}

                  {column.isShortIcon && (
                    <span
                      onClick={() => column.getSortByToggleProps().onClick()}
                      className="ms-2 cursor-pointer"
                    >
                      <i
                        title="Ascending"
                        className={`bi bi-arrow-up info-icon ${
                          column.isSorted && !column.isSortedDesc
                            ? "text-dark"
                            : ""
                        }`}
                      ></i>
                      <i
                        title="Descending"
                        className={`bi bi-arrow-down info-icon ${
                          column.isSorted && column.isSortedDesc
                            ? "text-dark"
                            : ""
                        }`}
                      ></i>
                    </span>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      className={cell.column.className}
                      key={index}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  )
}

const TeamsActivityTab = () => {
  const [editTeams, setEditTeams] = useState(false)
  const [addTeam, setAddTeam] = useState(false)
  const [data, setDatas] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [editId, setEditId] = useState("")
  const [editName, setEditName] = useState("")
  const [editAmount, setEditAmount] = useState("")
  const [addName, setAddName] = useState("")
  const [addAmount, setAddAmount] = useState("")
  const [modal_Access, setAccessDenied] = useState(false)



  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isShortIcon: true,
        className: "text-center mt_id",
      },
      {
        Header: "Members",
        accessor: "members",
        isInfoIcon: true,
        isShortIcon: true,
        className: "mt_members",
        Cell : cellProps => {
            return(
                <div className="text-start">
                    {cellProps.row.original.members}
                </div>
            )
        }
      },
   
      {
        Header: "Action",
        accessor: "action",
        className: "text-center oe-action",
        Cell: cellProps => {
          return (
            <div>
              <button
                onClick={() => {
                  {
                    setEditTeams(true)
                  }
                }}
                className="btn action-btn btn-sm me-1 btn-outline-secondary"
              >
                <i className="fas fa-pencil-alt"></i>
              </button>
              <Link
                onClick={() => handleDelete()}
                to="#"
                className="btn btn-sm action-btn btn-danger"
              >
                <i className="fas fa-trash-alt"></i>
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )

  const datas = [
    {
        id:"1", 
        members: "Rahul Ovhal"

    },
    {
        id:"2", 
        members: "Zain Marchawala"

    },
    {
        id:"3", 
        members: "Mohit K"

    },
    {
        id:"4", 
        members: "Yasir Khan"

    },
    {
        id:"5", 
        members: "Janvi Bhagat"

    },
  ]

  return (
    <>
      <div>
        <Row className="ms-0 pe-0">
          <Col lg={12} className="p-0">
            <Card>
              <CardBody>
                <TableContainer
                  columns={columns}
                  data={datas}
                  setLoading={setLoading}
                  setDatas={setDatas}
                  setAddTeam ={setAddTeam }
                  setAccessDenied={setAccessDenied}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

    {/* Add Teams Modal  */}
        <Modal
        isOpen={addTeam}
        centered
        size="xl"
        >
        <div className="modal-header">
            <h5 className="modal-title mt-0">Add Lead Tab</h5>
            <button
            type="button"
            onClick={() => {
                setAddTeam(false)
            }}
            className="btn-modal-close"
            >
            <span className="btn-modal-span">&times;</span>
            </button>
        </div>
        <div className="modal-body">
            <Form>
            <Row>
              <div className="col-5">
                <img src={addTeamsImg} className="img-fluid" style={{minHeight:"350px"}}/>
              </div>
              <div className="col-7 d-flex align-items-center justify-content-center flex-column">

                <div className="col-12 d-flex  align-items-start justify-content-start gap-2 mb-4">
                    <div className="mb-3 col-6">
                        <Label htmlFor="formrow-firstname-Input">Select Role <span className="text-danger">*</span></Label>
                        <Select
                            placeholder="Select Role"
                            className="basic-multi-select"
                            classNamePrefix=" select"
                            options={rolesOptions}
                        />
                    </div>
{/* 
                  <div className="col-5 d-flex  justify-content-start align-items-center gap-1 pt-1 ms-4">
                    <div className="d-flex flex-column justify-content-center align-items-center gap-1 pt-0 ms-4">
                
                      <Label className="text-gray mt-0 mb-0">Lead Tab Access</Label>
                 
                      <div className="form-switch form-switch-lg">
                      <input
                        title="Lead Tab Access"
                        type="checkbox"
                        className="form-check-input"
                        id="customSwitchsizemd"
                       
                      />
                      </div>
                    </div>
                  </div> */}

                </div>

                    <div className="col-12 d-flex align-items-start justify-content-start gap-2">
                      <div className="mb-3 col-12">
                        <Label htmlFor="formrow-firstname-Input">Select Member <span className="text-danger">*</span></Label>
                        <Select
                          placeholder="Select Member"
                          className="basic-multi-select"
                          classNamePrefix=" select"
                          isMulti="true"
                          options={StaffOption}
                        />
                      </div>
                    </div>

              </div>
            </Row>
            <div className="border-bottom my-3"></div>
            <div className="text-end">
                <button className="btn btn-save btn-label">
                <i className="fas fa-save me-2 label-icon"></i>
                Submit
                </button>
                <button className="btn btn-red btn-label ms-3">
                <i className="dripicons-cross icon-center me-2 label-icon"></i>
                Cancel
                </button>
            </div>
            </Form>
        </div>
        </Modal>

      {/* Edit Teams Modal */}
      <Modal
        isOpen={editTeams}
        centered
        size="xl"
        >
        <div className="modal-header">
            <h5 className="modal-title mt-0">Edit Lead Tab</h5>
            <button
            type="button"
            onClick={() => {
                setEditTeams(false)
            }}
            className="btn-modal-close"
            >
            <span className="btn-modal-span">&times;</span>
            </button>
        </div>
        <div className="modal-body">
            <Form>
            <Row>
              <div className="col-5">
                <img src={editTeamsImg} className="img-fluid" style={{minHeight:"350px"}}/>
              </div>
              <div className="col-7 d-flex align-items-center justify-content-center flex-column">

                <div className="col-12 d-flex  align-items-start justify-content-start gap-2 mb-4">
                    <div className="mb-3 col-5">
                        <Label htmlFor="formrow-firstname-Input">Select Role <span className="text-danger">*</span></Label>
                        <Select
                            placeholder="Select Role"
                            className="basic-multi-select"
                            classNamePrefix=" select"
                            options={rolesOptions}
                        />
                    </div>

                  {/* <div className="col-5 d-flex  justify-content-start align-items-center gap-1 pt-1 ms-4">
                    <div className="d-flex flex-column justify-content-center align-items-center gap-1 pt-0 ms-4">
                
                      <Label className="text-gray mt-0 mb-0">Lead Tab Access</Label>
                 
                      <div className="form-switch form-switch-lg">
                      <input
                        title="Lead Tab Access"
                        type="checkbox"
                        className="form-check-input"
                        id="customSwitchsizemd"
                       
                      />
                      </div>
                    </div>
                  </div> */}

                </div>

                    <div className="col-12 d-flex align-items-start justify-content-start gap-2">
                      <div className="mb-3 col-12">
                        <Label htmlFor="formrow-firstname-Input">Select Member <span className="text-danger">*</span></Label>
                        <Select
                          placeholder="Select Member"
                          className="basic-multi-select"
                          classNamePrefix=" select"
                          isMulti="true"
                          options={StaffOption}
                        />
                      </div>
                    </div>

              </div>
            </Row>
            <div className="border-bottom my-3"></div>
            <div className="text-end">
                <button className="btn btn-save btn-label">
                <i className="fas fa-save me-2 label-icon"></i>
                Submit
                </button>
                <button className="btn btn-red btn-label ms-3">
                <i className="dripicons-cross icon-center me-2 label-icon"></i>
                Cancel
                </button>
            </div>
            </Form>
        </div>
        </Modal>

    

      {/* Access Denied */}

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
      {/* ------------ */}
    </>
  )
}

export default TeamsActivityTab
